import React from 'react'
import Crd from '../images/crd.svg'
import Tbl from '../images/tbl.svg'
import { useDispatch, useSelector } from 'react-redux';
import { changeThemeShow } from '../redux/slices/adminSlice';
import { FormControlLabel, Switch, styled } from '@mui/material';
const MaterialUISwitch = styled(Switch)(({ theme }) => ({
    width:59,
    height: 30,
    padding: 8,
    '& .MuiSwitch-switchBase': {
      margin: 1,
      padding: 0,
      transform: 'translateX(6px)',
      '&.Mui-checked': {
        color: '#fff',
        transform: 'translateX(22px)',
        '& .MuiSwitch-thumb:before': {
          backgroundImage: `url(${Crd})`,
          backgroundSize:'20px'
        },
        '& + .MuiSwitch-track': {
          opacity: .3,
          backgroundColor: theme.palette.mode === 'dark' ? 'green' : 'green',
        },
      },
    },
    '& .MuiSwitch-thumb': {
      backgroundColor: theme.palette.mode === 'dark' ? 'green' : 'green',
      
      width: 28,
      height: 28,
      opacity:.8,
      '&::before': {
        content: "''",
        position: 'absolute',
        width: '100%',
        height: '100%',
        left: 0,
        top: 0,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundImage: `url(${Tbl})`,
        backgroundSize:'20px'
      },
    },
    '& .MuiSwitch-track': {
      opacity: 1,
      backgroundColor: theme.palette.mode === 'dark' ? '#8796A5' : '#aab4be',
      borderRadius: 20 / 2,
    },
  }));



const SwitchComponent = () => {
    const dispatch=useDispatch()
    const {currentTheme}=useSelector(state=>state.p.admin)
  return (
    <FormControlLabel  control={<MaterialUISwitch  defaultChecked />}   checked={currentTheme} onChange={()=>{dispatch(changeThemeShow(!currentTheme))}}   color="success" />
  )
}

export default SwitchComponent
